import { Box } from "@mui/material";

/**
 * The emphasis a mail merge (Serienbrief) string may carry, for `<Trans components={...}>`. Paths
 * are set in monospace the way every other technical value in the app is, so the folder the user has
 * to find reads as one token rather than as prose.
 */
export const MAIL_MERGE_TEXT_EMPHASIS = {
  bold: <strong />,
  path: <Box component="span" sx={{ fontFamily: "monospace", fontWeight: "bold" }} />,
};
